export { ZoomOutShot, type ZoomOutShotProps } from './ZoomOutShot';
